export default {
  BLANK_PAGE_TEMPLATE_ID: 'blank',
  SHOP_PAGE_TEMPLATE_ID: 'shop',
  ACTIVE_PAGE_KEY: 'active-page',
};
